import { createLazyFileRoute } from "@tanstack/react-router";

import { trpc } from "@blis/trpc/react";

import { ProcessTable } from "@/features/admin/components/processes/ProcessTable";
import { Section } from "@/features/admin/components/Section";

export const Route = createLazyFileRoute("/_auth/admin/processes/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { data } = trpc.admin.process.listTemplates.useQuery();
  return (
    <>
      <Section.Title>Processes</Section.Title>
      <ProcessTable templates={data} />
    </>
  );
}
